// Preferência de tema guardada no navegador. A mesma chave é lida pelo script
// inline de public/index.html, que aplica o tema antes do app carregar.
export const CHAVE_TEMA = "pontofiq.tema";

const TEMAS_VALIDOS = ["claro", "escuro"];

export function lerTemaSalvo() {
  try {
    const tema = localStorage.getItem(CHAVE_TEMA);
    return TEMAS_VALIDOS.includes(tema) ? tema : null;
  } catch (e) {
    return null;
  }
}

export function salvarTema(tema) {
  try {
    if (TEMAS_VALIDOS.includes(tema)) {
      localStorage.setItem(CHAVE_TEMA, tema);
    } else {
      localStorage.removeItem(CHAVE_TEMA);
    }
  } catch (e) {
    // localStorage indisponível (modo privado): o tema vale só para a sessão.
  }
}

export function mediaTemaEscuro() {
  return window.matchMedia ? window.matchMedia("(prefers-color-scheme: dark)") : null;
}

export function sistemaPrefereEscuro() {
  const media = mediaTemaEscuro();
  return Boolean(media && media.matches);
}

/** Tema salvo; sem escolha, segue o sistema operacional. */
export function temaInicialEscuro() {
  const salvo = lerTemaSalvo();
  return salvo ? salvo === "escuro" : sistemaPrefereEscuro();
}
